// extracted by mini-css-extract-plugin
export default {"iconLeft":"Button_iconLeft__cz4TN","iconRight":"Button_iconRight__nuZwV"};